import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'PAYMENT_GET',
  GET_SUCCESS: 'PAYMENT_GET_SUCCESS',
  GET_FAILURE: 'PAYMENT_GET_FAILURE',
};

export const get = actions.get(
  (studentId, query) => `${BASE_URL}/payment/${studentId}/discounts/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
